// TODO: Eventually use parcel limits to enforce this dynamically
// https://hubspot.slack.com/archives/C051L4J1WR5/p1683562356428609?thread_ts=1683561795.897789&cid=C051L4J1WR5
export const DEFAULT_WEBHOOK_TRIGGER_EVENT_LIMIT = 10;
export const WEBHOOK_TRIGGER_EVENT_LIMIT_NAME = 'webhook-trigger-event-limit';